import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Nav } from "@/components/portfolio/Nav";
import { Hero } from "@/components/portfolio/Hero";
import { About } from "@/components/portfolio/About";
import { SelectedFilms } from "@/components/portfolio/SelectedFilms";
import { BehindTheScenes } from "@/components/portfolio/BehindTheScenes";
import { FeatureFilm } from "@/components/portfolio/FeatureFilm";
import { Showreel } from "@/components/portfolio/Showreel";
import { Contact } from "@/components/portfolio/Contact";

const Home = () => {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#050505] text-white">
      <Nav />
      <main>
        <Hero />
        <About />
        <SelectedFilms />
        <FeatureFilm />
        <Showreel />
        <BehindTheScenes />
        <Contact />
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
